/**
 * メッセージ記録ファイル
 */
// tslint:disable-next-line:no-namespace
export namespace Message {

    /** E0000 エラー（仮メッセージ） */
    export const E0000 = 'エラーが発生しました。';

    /** I0001 削除確認 */
    export const I0001 = '選択したデータを削除してよろしいですか？';

    /** I0002 削除成功 */
    export const I0002 = '削除しました。';

    /** I0003 登録確認 */
    export const I0003 = '入力された内容で登録してよろしいですか？';

    /** I0004 登録成功 */
    export const I0004 = '登録しました。';

    /** I0005 一時保存確認 */
    export const I0005 = '入力内容を保存しますか？';

    /** I0006 一時保存成功 */
    export const I0006 = '入力内容を保存しました。';

    /** I0007 一時保存中止 */
    export const I0007 = '入力内容の保存を中止しました。';

    /** I0008 ファイル読込成功 */
    export const I0008 = 'ファイルの読込に成功しました。';

    /** E0009 ファイル読込成功 */
    export const E0009 = 'ファイルの読込に失敗しました。';

    /** E0010 ログイン失敗 */
    export const E0010 = 'ログインエラー。';

    /** I0011 ログイン成功 */
    export const I0011 = 'ログインしました。';

    /** W0012 希望確認 */
    export const W0012 = 'e.ve.ut.2018:個別情報を登録するには、対象自治体の選択が必要です。';

    /** W0013 希望確認 */
    export const W0013 = 'e.ve.ut.2021:個別情報を登録するには、資格分類の選択が必要です。';

    export const I0014 = '現在入力中の内容は保存されません。前の画面に戻ってもよろしいでしょうか？';

    // 2025.10.17 [R7年度改修作業（PKGエンハンス適用）] add start
    export const I0015 = '前の画面に戻ってよろしいですか？';

    export const I0016 = '入力内容が変更されていますが、画面遷移してよろしいですか？';
    // 2025.10.17 [R7年度改修作業（PKGエンハンス適用）] add end

    /** I0021 ファイルダウンロード確認 */
    export const I0021 = '選択したファイルをダウンロードしてよろしいですか？';

    /** I0022 ファイルダウンロード完了 */
    export const I0022 = 'ファイルのダウンロードが完了しました。';

    /** I0023 必須ファイル削除確認 */
    export const I0023 = '選択したファイルは必須ファイルです。削除する場合は再度アップロードして下さい。';

    /** I0024 更新確認 */
    export const I0024 = '現在の画面の内容でデータを更新してもよろしいですか？';

    /** I0025 前回複写確認 */
    export const I0025 = '前回の個別申請情報を複写登録します。\n現在の入力情報は削除されますがよろしいでしょうか？';

    /** W0025 希望業種選択 */
    export const W0025 = '希望業種を選択してください。';

    /** W0026 登録必須 */
    export const W0026 =  '希望業種を選択するには登録業種である必要があります。';

    /** I0027 パスワード発行確認 */
    export const I027 =  'パスワードを発行します。よろしいですか？\n業者名：';

    /** I0028 ステータス変更確認 */
    export const I028 =  '申請書を受け付け、処理状況を変更します。よろしいですか？';

    /** I0029 削除確認 ファイル用 */
    export const I0029 = '選択したファイルを削除してよろしいですか？';

    /** I0030 経審情報再反映確認 */
    export const I0030 = '入力された建設業許可番号を元に最新のCE財団情報を取り込みます。よろしいですか？';

    /** I0031 CE財団連携データ管理 受付データ退避確認 */
    export const I0031 = '基準日時点で最新のデータを取得し、受付反映予定データを更新します。\n全業者データ入れ替えの為数分かかります。よろしいですか？';

    /** I0032 CE財団連携データ管理 過去年度受付データ削除確認 */
    export const I0032 = '過去年度の受付反映済データを削除します。よろしいですか？';

    // 2025/8/22 [R7年度改修作業（PKGエンハンス適用）] add start
     /** I0033 申請取消確認（発注者） */
    export const I0033 = '選択した申請データを取消しますがよろしいですか？';
    /** I0034 申請取消確認（受注者） */
    export const I0034 = '選択した年度の申請データを取消しますがよろしいですか？';
    // 2025/8/22 [R7年度改修作業（PKGエンハンス適用）] add end

}
